import { Phone, Mail } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const TeamCard = ({ member }) => {
  return (
    <Card
      data-testid="team-member-card"
      className="rounded-[14px] border border-[color:var(--line)] bg-[color:hsl(var(--card))] p-6 flex flex-col gap-3 hover:shadow-[0_16px_44px_rgba(43,43,43,0.08)] transition-shadow duration-200"
    >
      <div className="h-1 w-10 gold-gradient-surface rounded-full" />
      <h3 className="font-[var(--font-serif)] text-lg text-[color:var(--brand-charcoal)]">{member.name}</h3>
      <p className="text-sm text-[color:hsl(var(--muted-foreground))]">{member.title}</p>
      <Separator className="bg-[color:var(--line)]" />
      <div className="flex flex-col gap-2 text-sm">
        <a
          href={`tel:${member.phone.replace(/\s/g, "")}`}
          data-testid="team-card-phone-link"
          className="flex items-center gap-2 text-[color:var(--brand-charcoal)] hover:text-[color:var(--brand-gold-2)] transition-colors"
        >
          <Phone className="h-4 w-4 text-[color:var(--brand-gold)] shrink-0" /> {member.phone}
        </a>
        <a
          href={`mailto:${member.email}`}
          data-testid="team-card-email-link"
          className="flex items-center gap-2 text-[color:var(--brand-charcoal)] hover:text-[color:var(--brand-gold-2)] transition-colors break-all"
        >
          <Mail className="h-4 w-4 text-[color:var(--brand-gold)] shrink-0" /> {member.email}
        </a>
      </div>
    </Card>
  );
};

export default TeamCard;
